"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClassifierValue = void 0;
const hooks_1 = require("../../../../ui/hooks");
const usePlatformSdkReactTranslation_1 = require("../../../../ui/hooks/usePlatformSdkReactTranslation");
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const ClassifierValue = ({ entity, id, fontSize, variant }) => {
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    const storage = (0, hooks_1.useStorageClient)(entity);
    const [response, setResponse] = react_1.default.useState();
    const [error, setError] = react_1.default.useState();
    react_1.default.useEffect(() => {
        if (id) {
            storage
                .list({ filter: [{ id: id, op: '=' }], limit: 1 })
                .then(setResponse)
                .catch(setError);
        }
        else {
            setResponse(undefined);
            setError(undefined);
        }
    }, [storage, entity, id]);
    if (response && response.rows.length > 0) {
        return (react_1.default.createElement(material_1.Typography, { component: 'span', fontSize: fontSize, variant: variant },
            response.rows[0].columns.name,
            response.rows[0].columns.status !== 'active' &&
                ' (' + t(`classifiers.statusEnum.${response.rows[0].columns.status}`) + ')'));
    }
    else if (error) {
        return (react_1.default.createElement(material_1.Typography, { component: 'span', color: 'error', fontSize: fontSize }, "Error"));
    }
    else {
        return react_1.default.createElement(material_1.Typography, { component: 'span', fontSize: fontSize });
    }
};
exports.ClassifierValue = ClassifierValue;
